<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form
        :ref="form"
        :model="form"
        label-width="80px"
        style="padding: 0 5px"
      >
        <div style="font-size: 12px; margin: 0px 0 16px 8px">
          <span>请选择批量设计的产品及图片：</span>
          <span style="float: right"> </span>
        </div>
        <el-row style="padding: 0 20px" :gutter="100">
          <el-col :span="8">
            <el-button
              style="width: 100%; height: 39px; font-size: 15px; padding: 6px 0"
              @click="handleShowProduct"
              size="mini"
              type="primary"
              >选择产品</el-button
            >
          </el-col>
          <el-col :span="8">
            <el-button
              style="width: 100%; height: 39px; font-size: 15px; padding: 6px 0"
              @click="handleShowImage"
              size="mini"
              type="primary"
              >选择主题图</el-button
            >
          </el-col>
          <el-col :span="8">
            <el-button
              v-if="false"
              style="width: 100%; height: 39px; font-size: 15px; padding: 6px 0"
              @click="handleShowImage"
              size="mini"
              type="primary"
              >选择背景图</el-button
            >
          </el-col>
        </el-row>

        <div style="font-size: 12px; margin: 0px 0 16px 8px">
          已选
          <span style="color: red">{{ productList.length }}</span> 个空白产品，
          <span style="color: red">{{ imageList.length }}</span> 张主题图， 0
          张背景图
          <el-button size="small" type="primary" style="margin-left: 10px;" @click="render">开始合成</el-button>
        </div>
      </el-form>
    </div>
    <!-- <div id="designer" style="display: none"></div> -->
    <iframe 
      style="display: none"
      id="designer-frame" 
      ref="designerFrame"
      class="designer-iframe"
      src="/iframe-designer/index.html?customHeader=true&customSidebar=true&customRightBox=true" 
      width="100%" 
      height="97%" 
      frameborder="0">
    </iframe>

    <div class="tab-body" style="margin-top: 0">
      <div
        v-for="(record, value) in groupData"
        :key="value"
        class="product-list"
      >
        <div v-if="record && record.length > 0" class="bar-title pl10">{{ record && record[0] ? record[0].proName : '' }}</div>
        <template v-for="(item, index) in record">
          <div class="pro-card">
            <div
              @click="handlePreivew(item.sku, item.designId)"
              class="card-img"
            >
              <!-- item.thumb -->
              <img
                :style="{ height: imageHeight + 'px' }"
                style="width: 100%"
                :src="
                  item.mainList ? item.mainList[item.currentProduct].picUrl : ''
                "
                lazy
              />
            </div>
            <div :class="`sku-img-list tp-${index}`">
              <div class="img-content">
                <ul>
                  <li
                    :class="{ 'is-select': item.currentProduct === number }"
                    @mouseover="handleSelectSku(item, number)"
                    v-for="(record, number) in item.mainList"
                    :key="number"
                  >
                    <img fit="contain" :src="record.picUrl" />
                  </li>
                </ul>
              </div>
            </div>

            <div class="card-info">
              <div class="info-div">
                <div class="detail">
                  <div :title="item.proName" class="product-title">
                    {{ item.proName }}
                  </div>
                  <div class="product-buttons">
                    <el-button
                      @click="handleDeleteProduct(item)"
                      type="danger"
                      size="mini"
                      >删除产品</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div v-if="groupData.length == 0" class="hint">
        没有符合条件的合成产品，请选择产品
      </div>

      <div class="batch-Synthesis letter">
        <div class="batch-Synthesis-info">
          <span class="batch-Synthesis-num cw">预计合成<b>{{ estimatedSynthesis }}</b>个定制产品</span>
          <!-- <span class="batch-Synthesis-total"
            >今日可再批量设计<b>100</b>个</span
          > -->
          <div class="fr">
            <el-button @click="handleSaveDesign" size="mini"
              >保存批量设计</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <ProductDialog
      v-model="productDialogVisible"
      @select="handleSelectProduct"
    ></ProductDialog>
    <ImageDialog
      v-model="imageDialogVisible"
      @select="handleSelectImage"
    ></ImageDialog>
    <el-dialog
      :close-on-click-modal="false"
      title="效果图预览"
      :visible.sync="previewImagesVisible"
      width="800px"
    >
      <div class="preview-area">
        <div class="carousel">
          <el-carousel
            ref="carouselPreview"
            style="height: 500px; overflow: hidden"
            :autoplay="false"
            :interval="5000"
            arrow="always"
          >
            <el-carousel-item
              v-for="(productImage, index) in productImageList"
              :key="index"
            >
              <img :src="productImage" />
            </el-carousel-item>
          </el-carousel>
          <div class="color-picker">
            <ul class="color-picker-list">
              <li
                @click="handlePickColor(record)"
                v-for="record of colorList"
                :key="record"
                :class="{ cur: currentColor === record }"
              >
                <a :style="{ backgroundColor: dictMap['color'][record] }"></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="preview-list">
          <div
            v-for="(productImage, index) in productImageList"
            :key="index"
            class="preview-list-item"
            :class="{ 'is-active': activeCarousel === index }"
            @click="handleClickPreviewImage(index)"
          >
            <img :src="productImage" />
            <div class="preview-text">效果图{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <div v-if="messageVisible" class="custom-message">
      <i class="el-icon-loading"></i>
      <div class="custom-message-content">{{ customContent }}</div>
      <!-- <i class="el-icon-close"></i> -->
    </div>
  </div>
</template>

<script>
import ProductDialog from "./components/ProductDialog"
import ImageDialog from "./components/ImageDialog"
import axios from "axios"
import { mapGetters } from "vuex"
import { getProductList } from "@/api/customProduct/product"
import { renderDesign } from "@/api/customProduct/design"
import { listType } from "@/api/sysSupport/category"
import Breadcrumb from "@/components/common/Breadcrumb"
import { addDesign } from "@/api/customProduct/design"
// import "simple-designer"
// import { uploadFile } from "./upload"
// import { uploadFileNew } from "./uploadNew"

import { addUserDesign, addUserDesignNew } from "@/api/customProduct/design"
import { Base64 } from "js-base64"
import designCacheDB from '@/utils/designCacheDB'

export default {
  name: "createBatchNew",
  components: { Breadcrumb, ProductDialog, ImageDialog },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
    estimatedSynthesis() {
      return this.productList.length*this.imageList.length
    },
  },
  data() {
    return {
      total: 6,
      form: {
        production_type: "",
        basic_category_id: undefined,
        production_cycle: undefined,
        page: 1,
        limit: 30,
        keyword: "",
      },
      productDialogVisible: false,
      imageDialogVisible: false,
      tableData: [],
      productList: [],
      renderData: [],
      imageList: [],
      // basicIdArray: [],
      proCodeArray: [],
      form: {
        pId: "3",
        printsParams: "",
        skuList: [],
        mapIds: ["1", "2"],
        canvasJson: "",
        designId: "",
      },
      imageWidth: "",
      imageHeight: "",
      SimpleDesigner: null,
      defaultImageData4: {
        originalUrl:
          "https://ddd-files.oss-accelerate.aliyuncs.com/galleries/1/20211202110828-GZWSBwpzjj.jpeg",
        url: "https://ddd-files.oss-accelerate.aliyuncs.com/galleries/1/20211202110828-GZWSBwpzjj-thumb.jpeg",
        info: {
          width: 664,
          height: 1024,
          type: "image/jpeg",
          size: 9918904,
        },
        name: "测试图片",
        width: 664,
        height: 1024,
      },
      // results: [],
      previewImagesVisible: false,
      productImageList: [],
      currentColor: "",
      samples: [],
      activeCarousel: 0,
      colorList: [],
      isSubmit: false,
      groupData: [],
      frame: null,
      reqCount: 0,
      reqIdList: [],
      aliyunOssToken: null,
      notificationCount: 0,
      messageVisible: false,
      customContent: '',
      renderStatus: false, //true合成中
    }
  },
  methods: {
    handleSelectSku(item, number) {
      item.currentProduct = number
    },
    handleShowProduct() {
      this.productDialogVisible = true
    },
    async handleSelectProduct(array) {
      this.tableData = array
      this.productList = this._.clone(array)
      // console.log('productList: ',this.productList)
      this.proCodeArray = []
      this.groupData = []
      array.map((item) => {
        this.proCodeArray.push(item.proCode)
        this.groupData.push([item])
      })
      this.$nextTick(() => {
        let cardImg = document.querySelector(".card-img")
        if (cardImg) {
          let height = cardImg.offsetWidth
          this.imageWidth = cardImg.offsetWidth
          this.imageHeight = height
        }
      })
      // this.render()
    },
    handleShowImage() {
      this.imageDialogVisible = true
    },
    handleSelectImage(array) {
      this.imageList = []
      for (let record of array) {
        this.imageList.push({
          mapId: record.mapId,
          name: record.picName,
          url: record.picUrl,
          // bgColor: '#ff0000' // (可选) 单独指定该图的背景色
        })
      }
      // this.render()
    },
    async render() {
      //开始合成图片
      if (this.imageList.length === 0) {
        this.$message.error('请选择产品')
        return
      }
      if (this.proCodeArray.length === 0) {
        this.$message.error('请选择图片')
        return
      }
      // this.startLoading()
      if (this.renderStatus) {
        // 合成进行中
        return
      }
      this.renderStatus = true
      this.bulkDesign(this.proCodeArray, this.imageList)
    },
    handleDeleteProduct(item) {
      let groupData = this._.clone(this.groupData)
      for (let record of groupData) {
        for (let i = 0; i < record.length; i++) {
          if (item.saveData) {
            // 删除设计产品
            if (record[i].designId == item.designId) {
              record.splice(i, 1)
              break
            }
          } else {
            // 删除未设计产品
            if (record[i].basicId == item.basicId) {
              record.splice(i, 1)
              break
            }
          }
        }
      }
      this.groupData = []
      this.groupData = groupData
      if (item.saveData) {
        // 删除设计产品
        const tableIndex = this.tableData.findIndex(v => v.designId == item.designId)
        this.tableData.splice(tableIndex, 1)
      } else {
        // 删除未设计产品
        const tableIndex = this.tableData.findIndex(v => v.basicId == item.basicId)
        this.tableData.splice(tableIndex, 1)
      }
      // console.log('tableData: ',this.tableData)
    },
    handlePreivew(proCode, designId) {
      // console.log('tableData: ',this.tableData)
      for (let record of this.tableData) {
        if (record.sku === proCode && designId === record.designId) {
          this.samples = record.effects
          break
        }
      }
      if (!this.samples || this.samples.length == 0) { //非合成商品，无法预览
        return
      }
      this.previewImagesVisible = true
      this.colorList = []
      for (let record of this.samples) {
        if (!this.colorList.includes(record.colorName)) {
          this.colorList.push(record.colorName)
        }
      }

      this.handlePickColor(this.colorList[0])

      this.$nextTick(() => {
        document.querySelector(".preview-list").scrollTop = 0
        this.handleClickPreviewImage(0)
        this.endLoading()
      })
    },
    handlePickColor(color) {
      this.currentColor = color
      this.setProductImageList()
    },
    setProductImageList() {
      let images = []
      for (let record of this.samples) {
        if (record.colorName === this.currentColor) {
          images.push(record.render_url)
        }
      }
      this.productImageList = images
    },
    handleClickPreviewImage(index) {
      this.$refs["carouselPreview"].setActiveItem(index)
      this.activeCarousel = index
    },
    bulkDesign(codes = [], images = []) {
      this.notificationCount = 0
      this.customContent = `产品合成中，预计合成${this.estimatedSynthesis}个定制产品，请勿关闭页面！`
      this.messageVisible = true
      this.frame = document.getElementById('designer-frame')
      this.frame.contentWindow.postMessage({
          type: 'SingleDesign',
          action: 'batchDesignStream',
          params: [{
              skus: codes, // 产品ID列表
              // backgroundColor: '#ffffff', // (可选) 全局背景色
              images: images, // 图片URL列表
          }]
      }, '*')
    },
    base64ToFile(base64Data, filename) {
      // 去除base64前缀（如果存在）
      const arr = base64Data.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1] || base64Data) // 如果没有前缀，直接使用整个字符串
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      
      return new File([u8arr], filename, { type: mime || 'image/png' })
    },
    async handleSaveDesign() {
      for (const item of this.tableData) {
        if(!item.saveData) {
          this.$message.error('请合成产品后保存！')
          return
        }
      }
      try {
        // if (this.results.length == 0) {
        if (this.tableData.length == 0) {
          this.msgError("请选择产品")
          return
        }
        if (this.isSubmit) {
          this.msgError("设计保存中...请稍等")
          return
        }

        this.isSubmit = true

        this.startLoading()

        this.$message({
          message: "正在保存...",
          type: "success",
          duration: 1000,
        })

        this.frame.contentWindow.SingleDesign.setSaveOptions({
          skipEffectSave: true  //是否跳过效果图保存 (默认为 false)
        })

        this.reqIdList = [] //重置请求记录
        this.reqCount = 0
        for (let record of this.tableData) {
          record.reqId = 'save_' + new Date().getTime()
          this.reqIdList.push(record.reqId)
          this.frame.contentWindow.postMessage({
            type: 'SingleDesign',
            action: 'saveBatchResult',
            params: record.saveData,
            reqId: record.reqId
          }, '*')
        }
      } catch (error) {
        console.log(error)
        this.isSubmit = false
      }
    },
  },
  async mounted() {
    window.addEventListener('message', async (event) => {
      var data = event.data
      if (!data) return

      if (data.type === 'SingleDesignBatchProgress') {
        // 1. 监听单个结果进度 (每处理完一张图触发一次)
        console.log('单个设计完成:', data.result)
        this.notificationCount++
        this.customContent = `已完成${this.notificationCount}个设计，共${this.estimatedSynthesis}个`

        if (this.notificationCount == 1) {
          // 加载第一张图时界面重置
          this.tableData = []
          this.groupData = []
        }

        let resultItem = this._.clone(data.result)
        for (let product of this.productList) {
          if (data.result.sku == product.proCode) {
            resultItem.proName = product.proName
            resultItem.currentProduct = 0
            resultItem.basicId = product.basicId
            resultItem.pId = product.pId
            resultItem.mainList = [
              {
                // picUrl: data.result.image,
                picUrl: data.result.effects[0].render_url,
                price: null,
                skuName: "Black",
              },
            ]
            break
          }
        }
        this.tableData.push(resultItem)
        //对表格数据根据产品进行归类
        if (this.groupData.length == 0) {
          this.groupData.push([resultItem])
        } else {
          let find = false
          for (let productList of this.groupData) {
            for (let product of productList) {
              if (product.sku == resultItem.sku) {
                productList.push(resultItem)
                find = true
                break
              }
            }
          }
          if (!find) {
            this.groupData.push([resultItem])
          }
        }
      } else if (data.type === 'SingleDesignBatchDone') {
        // console.log('监听全部完成事件: ', data)
        this.messageVisible = false
        // 2. 监听全部完成事件
        // this.endLoading()
        // this.results = data.results
        const allResults = data.results
        console.log('批量设计全部完成!', allResults)
        this.renderStatus = false
        console.log('groupData: ', this.groupData)
        console.log('tableData: ', this.tableData)
      } else if (data.type === 'SingleDesignResponse') {
        console.log('SingleDesignResponse: ',data)
        // 批量保存
        if (this.reqIdList.includes(data.reqId)) {
          const designId = data.result.id
          const curr = this.tableData.find(v => v.sku === data.result.goodsSku && v.reqId === data.reqId)
          const detail = await this.frame.contentWindow.SingleDesign.getDesignRecord(designId)
          // console.log('设计详情: ', detail)

          let form = {}
          form.mapIds = [curr.mapId]
          form.pId = curr.pId
          form.canvasJson = JSON.stringify(detail) //还原设计用
          form.printsParams = Base64.encode(designId)
          form.designId = ""
          form.isRedesign = "1"
          form.ifNew = '01'  //01：新，空：旧

          let localEffects = curr.effects
          const designData = {
            localEffects: localEffects,
            form: form,
            proCode: detail.goodsSku,
          }

          designCacheDB.createNotification({
            proName: curr.proName,
            reqId: data.reqId,
          })

          // 保存到 IndexedDB
          await designCacheDB.addDesign({
            id: 'design_' + Date.now(),
            data: designData,
            timestamp: Date.now(),
            status: 'pending',
            createdAt: new Date().toISOString(),
            userName: this.user.name,
            proName: curr.proName,
            reqId: data.reqId,
          })

          this.reqCount++
          if (this.tableData.length == this.reqCount) {
            this.$message({
              message: "批量设计保存成功",
              type: "success",
              duration: 1000,
            })
            this.tableData = []
            this.imageList = []
            this.productList = []
            this.groupData = []
            this.isSubmit = false
            this.endLoading()
          }
          // // console.log('form: ', form)
          // addUserDesign(form).then(res => {
          //   this.reqCount++
          //   if (this.tableData.length == this.reqCount) {
          //     this.$message({
          //       message: "批量设计保存成功",
          //       type: "success",
          //       duration: 1000,
          //     })
          //     this.tableData = []
          //     this.imageList = []
          //     this.productList = []
          //     this.groupData = []
          //     this.isSubmit = false
          //     this.endLoading()
          //   }
          // }).catch(err => {
          //   this.reqCount++
          //   // if (this.tableData.length == this.reqCount) {
          //   //   this.$message({
          //   //     message: "批量设计保存成功",
          //   //     type: "success",
          //   //     duration: 1000,
          //   //   })
          //   //   this.tableData = []
          //   //   this.imageList = []
          //   //   this.productList = []
          //   //   this.groupData = []
          //   //   this.isSubmit = false
          //   //   this.endLoading()
          //   // }
          // })
        }
      }
    })
  },
}
</script>

<style lang="scss" scoped>
#custom-online {
  width: 100%;
  ::v-deep .el-radio {
    color: rgb(89, 90, 90);
  }

  ::v-deep .el-form-item__label {
    color: rgb(89, 90, 90);
  }
}
#custom-online .tab-body .pro-card {
  padding: 0;
  margin-top: 0px;
}
#custom-online .tab-body .pro-card .pro-content {
  border: 0;
  border-radius: 5px;
  padding: 0px 8px 8px 8px;
  box-sizing: border-box;
}
#custom-online .tab-body {
  ::v-deep .el-form-item__content {
    line-height: 50px;
  }
  .product-list {
    overflow: hidden;
    ::v-deep .pro-card:first-child {
    }
    ::v-deep .pro-card:last-child {
    }

    .pro-card {
      width: calc(20% - 16px);
      float: left;
      box-sizing: border-box;
      margin: 4px 12px 12px 4px;
      padding: 16px 16px 6px 16px;
      background: #ffffff;
      border: 1px solid rgb(221, 221, 221);
      .detail {
        line-height: 30px;
      }
      .unit {
        font-size: 12px;
      }
      .card-img {
        cursor: pointer;
      }
      .image {
        padding: 16px;
        cursor: pointer;
      }
      .text {
        overflow: hidden;
        font-size: 14px;
      }
      .product-title {
        font-size: 14px;
        box-sizing: border-box;
        padding-bottom: 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .product-tag {
        line-height: 14px;
        margin: 0 0 10px 0;
        div {
          display: inline-block;
          font-size: 12px;
          padding: 2px 6px;
          background: #4934b2;
          border-radius: 5px;
          color: #ffffff;
        }
      }
      .factory {
        border-top: 1px solid #ebeef5;
      }
      .price {
        float: left;
        color: #4934b2;
        font-size: 18px;
        font-weight: bold;
      }
      .date {
        float: right;
      }
    }
    .pro-card:hover {
      cursor: auto;
      color: #000 !important;
      box-shadow: 0 0px 6px 0 #4934b2;
      transition: all 0.35s;
    }
  }
}
.form-body {
  margin-right: 8px;
  padding-bottom: 6px;
  padding: 10px 0;
}
.form {
  padding: 0 16px;
}

.sku-img-list {
  clear: both;
  width: 223px;
}
.sku-img-list .prev {
  float: left;
  margin-right: 2px;
}
.sku-img-list .next {
  float: right;
}
.sku-img-list .prev,
.tab-body .pro-card .pro-content .sku-img-list .next {
  display: block;
  font-family: "宋体";
  text-align: center;
  width: 10px;
  line-height: 40px;
  cursor: pointer;
  text-decoration: none;
}
.sku-img-list .img-content {
  position: relative;
  height: 46px;
  overflow: hidden;
}
.sku-img-list ul {
  position: absolute;
  width: 99999px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  list-style-type: none;
}
.sku-img-list ul li {
  float: left;
  width: 40px;
  height: 40px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ebeef5;
  margin-right: 4px;
  padding: 2px;
}
.sku-img-list ul li img {
  width: 40px;
  height: 40px;
}
.sku-img-list ul li img:hover {
}
.price-gradient-box {
  overflow: hidden;
  width: 100%;
  background: #fff;
  z-index: 100;
  transform: translateZ(1000px);
  font-size: 12px;
}
.price-gradient-box .weight-box {
  height: 42px;
  line-height: 42px;
  border: 1px solid #ededed;
  text-align: center;
}
.price-gradient-box .weight-box div:not(:first-child) {
  border-left: 1px solid #ededed;
}
.price-gradient-box > div {
  background: #fff;
}
.price-gradient-box:hover,
.com-pt-img:hover ~ .price-gradient-box {
  bottom: 5px;
  left: 0;
  overflow: hidden;
  z-index: 100;
  transform: translateZ(1000px);
}
.price-gradient-box .swiper-slide {
  text-align: center;
  border: 1px solid #ededed;
  padding: 10px 0;
}
.price-gradient-box .swiper-slide + .swiper-slide {
  border-left: none;
}
.product-swiper-box .next-btn,
.product-swiper-box .per-btn,
.price-gradient-box .next-btn,
.price-gradient-box .per-btn {
  z-index: 2;
  top: 60px;
  padding: 5px;
  width: 20px;
  height: 20px;
  line-height: 0px;
  background: rgba(235, 246, 255, 0.5);
  text-align: center;
}
.preview-area {
  overflow: hidden;
  .carousel {
    width: 600px;
    float: left;
    ::v-deep .el-carousel__item {
      text-align: center;
    }
    ::v-deep .el-carousel__container {
      height: 500px;
    }
    img {
      width: 500px;
      height: 500px;
    }
  }
  .preview-list {
    width: 130px;
    float: left;
    height: 500px;
    margin: 0 0 0 16px;
    overflow-y: auto;
    .preview-list-item {
      border: 1px solid #e5e5e5;
      margin: 0 8px 15px 0;
      box-sizing: border-box;
      width: 111px;
      height: 111px;
      position: relative;
      cursor: pointer;
      .preview-text {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        padding: 0.05rem 0;
        font-size: 0.14rem;
        z-index: 10;
        font-size: 14px;
      }
      &:hover .preview-text {
        display: block;
      }
      &.is-active .preview-text {
        display: block;
        background: #4934b2;
      }
    }

    img {
      width: 109px;
      height: 109px;
    }
    .is-active {
      border: 1px solid #4934b2;
    }
  }
  .color-picker {
    overflow: hidden;
    margin: 16px 8px 0 0;
    ul {
      overflow: hidden;
      padding: 0px 0 0 266px;
    }
  }

  .color-picker-list li,
  .color-picker-list-hover li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }
  .color-picker-list li.cur {
    border: #4934b2 solid 2px;
  }
  .color-picker-list li a,
  .color-picker-list-hover li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.w50 {
  width: 50% !important;
}
.flex-x-full {
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.flex-row {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}
.red {
  color: #ff4d3a !important;
}
.c153 {
  color: rgb(153, 153, 153);
}
.filter {
  background: #ffffff;
  border-top: 1px solid rgb(221, 221, 221);
  margin: 4px 0 0 0;
  overflow: hidden;
  padding: 12px 16px 0 16px;
}
.left {
  float: left;
}
.right {
  float: right;
}
.is-select {
  border: 1px solid #333333 !important;
}

#custom-online .tab-body .card-img:hover {
}
#custom-online .tab-body .pro-card .card-info {
  height: 72px;
}
.hint {
  background: #ffffff;
  height: 100px;
  line-height: 100px;
  padding: 16px;
  text-align: center;
  font-size: 14px;
  color: #999;
}
.product-buttons {
  text-align: right;
}

.batch-Synthesis {
  background-color: #4934b2;
  height: 42px;
  margin-top: 10px;
  line-height: 42px;
  padding: 0 10px;
  text-align: center;
  .letter > * {
    letter-spacing: normal;
    display: inline-block;
    vertical-align: top;
  }
  .fr {
    float: right !important;
  }
  .cw {
    color: #fff !important;
  }
  .batch-Synthesis-total {
    color: #f5e92d;
  }
  font-size: 14px;
  .no-batch {
    background-color: rgb(232, 231, 231);
    color: rgb(136, 136, 136);
    cursor: not-allowed !important;
  }
}
.bar-title {
  width: calc(100% - 50px);
  height: 38px;
  background-color: #f5f7fa;
  border: 1px solid #dddddd;
  line-height: 38px;
  color: #595a5a;
  padding: 0 20px;
  font-size: 13px;
  margin: 0 0 16px 0;
}
.custom-message {
  min-width: 380px;
  box-sizing: border-box;
  border: 1px solid #EBEEF5;
  position: fixed;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  background-color: #edf2fc;
  transition: opacity .3s, transform .4s, top .4s;
  padding: 15px 15px 15px 20px;
  display: flex;
  align-items: center;
  z-index: 2001;
  border-radius: 4px;
  overflow: hidden;
  .el-icon-loading {
    margin-right: 10px;
  }
  .custom-message-content {
    padding-right: 16px;
    color: #909399;
  }
  .el-icon-close {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    cursor: pointer;
    color: #C0C4CC;
    font-size: 16px;
  }
}
</style>
